var $ = require('../../modules/$');
require('../../modules/es6.object.get-own-property-descriptor');
module.exports = function getOwnPropertyDescriptor(it, key){
  return $.getDesc(it, key);
};


/*****************
 ** WEBPACK FOOTER
 ** /home/rengasturku/nettivanne/~/babel-runtime/~/core-js/library/fn/object/get-own-property-descriptor.js
 ** module id = 445
 ** module chunks = 0 1 2 3 10 11 12 17 19 20
 **/